module.exports = __webpack_public_path__ + "de16cf90f8d922d2baf07865c1ed807b.svg";